import { PortfolioEditorMode } from '@ddt-web/config';

export class PEState {
	public isModalVisible: boolean = false;
	public uniqueIdForPortfolioEditor: string = null;
	public comparisonIds: string[] = [];
	public engagementId: string = null;
	public assetClasses: string[] = [];
	public stressTests: string[] = [];
	public acBenchmark: string = null;
	public assetTypes: { displayName: string; label?: string; count?: number }[] = null;
	public urlIds: string[] = [];
	public portfolioEditorMode: PortfolioEditorMode = PortfolioEditorMode.NEW;
}
